import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


import backlogo from '../../Assets/App_icon/back.png';
import excellogo from '../../Assets/App_icon/excel.png';
import loader from '../../Assets/App_icon/loader.gif';

const NotifyMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  

  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false); 
  const [custModalVisible, setCustModalVisible] = useState(false); 
  const [wModalVisible, setWModalVisible] = useState(false); 
  
  const [areas, setAreas] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);

  const [gMsg, setGMsg] = useState('');
  const [eMsg, setEMsg] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageBase64, setImageBase64] = useState('');
  const [imageMimeType, setImageMimeType] = useState('');
  const [imageFilename, setImageFilename] = useState('');
  const [uploadImage, setUploadImage] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [sending, setSending] = useState(false);
  const [loadingText, setLoadingText] = useState("Sending notifications…");
 
  const [chekedCust, setChekedCust] = useState([]);
  const [chekedNotify, setChekedNotify] = useState([]);
 
  

  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => { 
      const fetchAreaList = async () => {       
          try {
            const response = await fetch(`${host_url}/area_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                areaId : '',
                areaName: '',
                areaEName: '',
              }),
            });
            const data = await response.json();
            setAreas(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAreaList(); 
    }, [host_url, customers]);

    useEffect(() => {
      document.title = "Notification";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      setImagePreview('');
      setUploadImage('');
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || custModalVisible || wModalVisible) {
            setModalVisible(false);
            setCustModalVisible(false);
            setWModalVisible(false);
          } else {
            handleBack();
          }
        }
        
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, custModalVisible, wModalVisible]);

    useEffect(() => { 
      const fetchCustList = async () => { 
          try {
            const response = await fetch(`${host_url}/cust_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                custId: '',
                custMo: '',
                custName: '',
                custEName: '',
                custAreaId: '',
                custAdd: '',
                custEAdd: '',
                custVerify: '',
                custRefno: '', 
              }),
            });
            const data = await response.json();
            setCustomers(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchCustList(); 
    }, [host_url, ]); // Fetch Customer Detail 

    useEffect(() => {
      setChekedNotify(chekedCust);
    }, [chekedCust]); // Customer Checked

    const handleCustDetail = (cust) => {
      setCustModalVisible(true);
      setSelectedCustomer(cust);
    };
    
    const [custIdFilter, setCustIdFilter] = useState('');
    const [custMoFilter, setCustMoFilter] = useState('');
    const [custNameFilter, setCustNameFilter] = useState('');
    const [custEAddFilter, setCustEAddFilter] = useState('');
    const [custAreaFilter, setCustAreaFilter] = useState('');
    const [custStatusFilter, setCustStatusFilter] = useState('');
    const [custAppVarFilter, setCustAppVarFilter] = useState('');
    const [custOSFilter, setCustOSFilter] = useState('');
    const [startOrder, setStartOrder] = useState('');
    const [endOrder, setEndOrder] = useState('');
    const [startLogin, setStartLogin] = useState('');
    const [endLogin, setEndLogin] = useState('');

    const filteredCustomers = customers.filter(customers =>
      String(customers.custId).toLowerCase().includes(custIdFilter.toLowerCase()) &&
      String(customers.custMo).toLowerCase().includes(custMoFilter.toLowerCase()) &&
      (
        String(customers.custEName || '').toLowerCase().includes(custNameFilter.toLowerCase()) ||
        String(customers.custName || '').toLowerCase().includes(custNameFilter.toLowerCase())
      ) &&
      (
        String(customers.custEAdd || '').toLowerCase().includes(custEAddFilter.toLowerCase()) ||
        String(customers.custAdd || '').toLowerCase().includes(custEAddFilter.toLowerCase())
      ) &&
      customers.custAreaEName.toLowerCase().includes(custAreaFilter.toLowerCase()) &&
      customers.custLang.toLowerCase().includes(custStatusFilter.toLowerCase()) &&
      customers.custPNToken.toLowerCase().includes(custOSFilter.toLowerCase()) &&
      (!custAppVarFilter || customers.custAppVar?.toLowerCase() === custAppVarFilter.toLowerCase() )&&
      (!startOrder || customers.custLastOrder >= startOrder) &&  (!endOrder || customers.custLastOrder <= endOrder) &&
      (!startLogin || customers.custLastLogin >= startLogin) &&  (!endLogin || customers.custLastLogin <= endLogin) 
      
    );

    const totalCount = filteredCustomers.length;

    // 🔥 Get unique custAppVar values from filtered customers
      const uniqueAppVersions = useMemo(() => {
        const vals = customers
          .map(c => c.custAppVar)
          .filter(v => v !== null && v !== undefined && String(v).trim() !== '')
          .map(v => String(v));

        // Remove duplicates + sort nicely
        return [...new Set(vals)].sort((a, b) => {
          const na = parseFloat(a), nb = parseFloat(b);
          if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
          return a.localeCompare(b, undefined, { numeric: true });
        });
      }, [filteredCustomers]);

    
    const handleCheckboxChange = (e, row, isChecked) => {
      if (isChecked) {
        setChekedCust([...chekedCust, row]);
      } else {
        setChekedCust(chekedCust.filter(cust => cust.custId !== row.custId));
      }
    };

    const handleSelectAllChange = (e) => {
      const isChecked = e.target.checked;
      
      if (isChecked) {
        setChekedCust(filteredCustomers);
      } else {
        // Deselect all checkboxes
        setChekedCust([]);
      }
    };

    // Function to send the push token to your server
      const sendPushTokenToServer = async () => {
        setModalVisible(false);
        setSending(true); 
        const custList = chekedNotify.map(customer => ({
          custId: customer.custId,
          custLang: customer.custLang,
          custOS: customer.custOS,              // ⚠️ make sure this is "android" / "ios"
          custName: customer.custName,
          custEName: customer.custEName,
          custPNTokenId: customer.custPNTokenId
        }));

        if (custList.length === 0) {
          alert("No customers selected.");
          return;
        }

        const formData = new FormData();
        formData.append("store", store);
        formData.append("gMsg", gMsg);
        formData.append("eMsg", eMsg);
        formData.append("custList", JSON.stringify(custList));

        if (uploadImage) {
          formData.append("image", uploadImage, uploadImage.name);
        }

        setSending(true);

        try {
          // 🔹 STEP 1: SEND BULK NOTIFY REQUEST
          const response = await fetch(`${host_url}/bulk_notify`, {
            method: "POST",
            body: formData,
          });

          if (!response.ok) {
            const text = await response.text();
            console.warn("bulk_notify failed", response.status, text);
            alert("Failed to start notification process.");
            return;
          }

          
          // 🔹 NOW THE REPORT IS HERE
          const json = await response.json();
          console.log("Delivery Report:", json.report);
          console.table(json.report);

          const updatedChekedCust = chekedCust.map(cust => ({
            ...cust,
            notifyStatus:
              json.report.find(r => r.custId === cust.custId)?.notifyStatus || "Unknown",
          }));
          console.log("after Notify", updatedChekedCust);
          setChekedCust(updatedChekedCust);
          await exportToExcel(updatedChekedCust);
          
          console.log(chekedCust);
          setChekedCust([]);



        } catch (error) {
          console.error("Network error:", error);
          alert("Network error while sending notifications.");
        } finally {
          setSending(false);
        }
      };



    // HAndle Image  
      const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setSelectedImage(file);
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result.split(',')[1]; // Remove data:image/...;base64,
            setImageBase64(base64String);
            setImageMimeType(file.type);
            setImageFilename(file.name);
          };
          reader.readAsDataURL(file);
        }
      };

    // Function to send WhatsApp Msg to your server
      const sendWMsgToServer = async () => {
        setWModalVisible(false);

        // Prepare customer list
        const custList = chekedNotify.map(customer => ({
          custLang: customer.custLang,
          custName: customer.custName,
          custEName: customer.custEName,
          custMo: customer.custMo
        }));

        try {
          const response = await fetch(`${host_url}/whatsapp/send-message`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              gMsg: gMsg,
              eMsg: eMsg,
              custList: custList,
              imageBase64: imageBase64,
              imageMimeType: imageMimeType,
              imageFilename: imageFilename
            }),
          });

          if (response.ok) {
            console.log('WhatsApp Message sent successfully.');
            setSelectedImage(null);
            setGMsg('');
            setEMsg('');
            setImageBase64('');
            setImageMimeType('');
            setImageFilename('');
            alert('WhatsApp Message sent successfully.');
          } else {
            console.warn('Failed to send WhatsApp Message.');
            alert('Failed to send WhatsApp Message.');
          }
        } catch (error) {
          console.error('Error sending WhatsApp Message:', error);
          alert('Error occurred while sending WhatsApp Message.');
        }
      };

    // notification Image Select  
      const handleImage = async (e) => {
        if (fileInputRef.current) {
          fileInputRef.current.click();
        }
      };

      const handleFileChange = async (e) => {
        const file = e.target.files[0];
        
        if(file) {
          setUploadImage(e.target.files[0]);
          const previewUrl = URL.createObjectURL(file);
          setImagePreview(previewUrl);
        } else {
          setUploadImage(null);
          setImagePreview('');
        }
      };  

    // Export To Excel   
    const exportToExcel = async (data) => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Stock Report');

      // Define headers
        worksheet.columns = [
          { header: 'Id', key: 'Id', width: 20 },
          { header: 'Area', key: 'Area', width: 30 },
          { header: 'Name', key: 'Name', width: 15 },
          { header: 'Address', key: 'Address', width: 15 },
          { header: 'Ordr_Day', key: 'Order_Day', width: 15 },
          { header: 'Login_Day', key: 'Login_Day', width: 15 },
          { header: 'Notify', key: 'Notify', width: 15 },
        ];

      // Add rows
        data.forEach(item => {
          worksheet.addRow({
            Id: item.custId,
            Area: item.custAreaEName,
            Name: item.custName,
            Address: item.custAdd,
            Order_Day: item.custLastOrder,
            Login_Day: item.custLastLogin,
            Notify: item.notifyStatus || '',
          });
        });


      // Apply borders to all cells in the worksheet
        worksheet.eachRow((row, rowNumber) => {
          row.height = 35;
          row.alignment = {vertical: 'middle'};
          row.eachCell(cell => {
            cell.border = {
              top:    { style: 'dotted' },
              left:   { style: 'dotted' },
              bottom: { style: 'dotted' },
              right:  { style: 'dotted' },
            };
          });
        });

      // ✅ Right-align "After_Order" and "Stock" columns
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          // After_Order = column 3, Stock = column 4 (1-based indexing)
          row.getCell(5).alignment = { vertical: 'middle', horizontal: 'right' };
          row.getCell(6).alignment = { vertical: 'middle', horizontal: 'right' };
        });

      // Apply header styles
        worksheet.getRow(1).eachCell(cell => {
          cell.font = { bold: true };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
          };
        });

      // Write to file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Marketing.xlsx');
    };  

    

  return (
    <div className="container">
          {sending && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.45)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <img src={loader} alt="Loading" />
              <div style={{ color: "#fff", marginTop: "10px", fontSize: "20px" }}>
                Sending notifications....<br />
                Please Wait 10–15 seconds
              </div>
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Notification Master</b>
              <div >
                {chekedCust.length > 0  && (
                  <div onClick={() => exportToExcel(chekedCust)}>
                    <img src={excellogo} alt="Back" className='system-icon'/>
                  </div>
                )}
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th><span style={{ display: 'flex', paddingLeft: '10px' }}>
                      <span>
                        <input
                          type="checkbox"
                          value="selectAll"
                          onChange={(e) => handleSelectAllChange(e)}
                        />
                      </span>
                      <span style={{ paddingLeft: '10px' }}>Mobile </span>
                    </span>
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custEAddFilter}
                    onChange={(e) => setCustEAddFilter(e.target.value)}
                    placeholder="Search By Address"
                  />
                </th>
                <th colSpan='2'>Area</th>
                <th>Lang</th>
                <th>OS</th>
                <th>Ver</th>
                <th>last Order</th>
                <th>last Login</th>
              </tr>
              <tr>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={custMoFilter}
                    onChange={(e) => setCustMoFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custNameFilter}
                    onChange={(e) => setCustNameFilter(e.target.value)}
                    placeholder="Search By Name"
                  />
                </th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={custAreaFilter}
                    onChange={(e) => setCustAreaFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    {areas.map((area) => (
                      area.customer > 0 && (
                        <option key={area.areaId} value={area.areaEName}>
                          {area.areaEName}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={custStatusFilter}
                    onChange={(e) => setCustStatusFilter(e.target.value)}
                  >
                    <option value="">All</option>
                    <option value="Gujarati">Guj</option>
                    <option value="English">Eng</option>
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={custOSFilter}
                    onChange={(e) => setCustOSFilter(e.target.value)}
                  >
                    <option value="">All</option>
                    <option value="iOS">iOS</option>
                    <option value="android">Android</option>
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={custAppVarFilter}
                    onChange={(e) => setCustAppVarFilter(e.target.value)}
                  >
                    <option value="">All Platform</option>
                    {uniqueAppVersions.map((ver) => (
                      <option key={ver} value={ver}>
                        {ver}
                      </option>
                    ))}
                  </select>
                </th>
                <th> 
                  <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={startOrder}
                        onChange={(e) => setStartOrder(e.target.value)}
                      />
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={endOrder}
                        onChange={(e) => setEndOrder(e.target.value)}
                      />
                  </div>    
                </th>
                <th> 
                  <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={startLogin}
                        onChange={(e) => setStartLogin(e.target.value)}
                      />
                      <input
                        type="text"
                        className="search-input"
                        style={{ width: '45%', textAlign: 'center' }}
                        value={endLogin}
                        onChange={(e) => setEndLogin(e.target.value)}
                      />
                  </div>    
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredCustomers.map((row) => {
                  return (
                    <tr key={row.custId} style={{ lineHeight: '10px', cursor: 'default' }} >
                      
                      <td onClick={(e) => {
                        e.stopPropagation();  
                        const checkbox = e.target.querySelector('input[type="checkbox"]');
                        if (checkbox) {
                          checkbox.checked = !checkbox.checked;
                          handleCheckboxChange(e, row, checkbox.checked);
                        }
                      }}>
                        <span style={{ display: 'flex', paddingLeft: '10px' }}>
                          <span>
                            <input
                              type="checkbox"
                              value={row.custId}
                              checked={chekedCust.some(order => order.custId === row.custId)}
                              onChange={(e) => handleCheckboxChange(e, row, e.target.checked)}
                            />
                          </span>
                          <span style={{ paddingLeft: 10, fontSize: '12px' }}>{row.custMo}</span>
                        </span>
                      </td>
                      <td colSpan='2' className="cell-left" onClick={() => handleCustDetail(row)} style={{ cursor: 'pointer' }} ><span style={{ paddingLeft: '10px' }} >{row.custEName}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.custAreaEName}</span></td>
                      <td className="cell-left" style={{paddingLeft: '10px'}}>{row.custLang}</td>
                      <td className="cell-left" style={{paddingLeft: '10px'}}>{row.custPNToken === 'android' ? 'Android' : 'iOS'}</td>
                      <td className="cell-left" style={{paddingLeft: '10px'}}>{row.custAppVar}</td>
                      <td className='cell-right'><span style={{ paddingRight: '10px' }}>{row.custLastOrder}</span></td>
                      <td className='cell-right'><span style={{ paddingRight: '10px' }}>{row.custLastLogin}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th colSpan='4'>
                    {chekedCust.length > 0  && (
                      <Button color="primary" style={{ marginTop: '5px', marginBottom: '5px', width: '50%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }}  onClick={() => setModalVisible(true)}>Send Notification</Button>
                    )}                     
                </th>
                <th colSpan='4'>
                    {chekedCust.length > 0  && (
                      <Button color="success" style={{ marginTop: '5px', marginBottom: '5px', width: '50%', paddingTop: '0px', paddingBottom: '0px', fontSize: '16px' }}  onClick={() => setWModalVisible(true)}>Whatsapp</Button>
                    )} 
                </th>
                
                <th></th>             
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Notification Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb',  paddingTop: '0px'}}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ width: '75%' }}> 
                      <h5 style={{ margin: 0 }}>Notification Detail</h5>
                    </div>  
                    <div style={{ width: '25%',  display: 'flex', justifyContent: 'flex-end', gap: '50px' }}>
                      <Button color="success" size="sm" onClick={sendPushTokenToServer} disabled={sending}>
                        {sending ? 'Sending...' : 'Send'}
                      </Button>
                      <Button color="primary" size="sm"  onClick={() => setModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                </div> 
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '58%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Id</th>
                          <th colSpan='2'style={{ paddingLeft: '10px' }} >Customer Name</th>
                          <th colSpan='2' style={{ paddingLeft: '10px' }} >Area </th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                          {chekedNotify.map((row, index) => {
                              return (
                                <tr key={index} style={{ lineHeight: '10px' }} >
                                  <td className="cell-left"><span style={{ paddingLeft: '10px' }} >{row.custId}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custEName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaEName}</span></td>
                                </tr>
                              );
                          })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Total</th>
                          <th colSpan='2' className="cell-left"  style={{ paddingLeft: '10px' }} >{chekedNotify.length}</th>
                          <th colSpan='2' ></th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Gujarati</td>
                          <td className="cell-left">
                            <textarea 
                              value={gMsg} 
                              onChange={(e) => setGMsg(e.target.value)} 
                              rows="4" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">English</td>
                          <td className="cell-left">
                            <textarea 
                              value={eMsg} 
                              onChange={(e) => setEMsg(e.target.value)} 
                              rows="4" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">Image</td>
                          <td className="cell-left" style={{ padding: '4px' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              {imagePreview ?(
                                <img 
                                  src={imagePreview} 
                                  alt="Category" 
                                  style={{ width: '100px', height: '100px', objectFit: 'contain', cursor: 'pointer'}} 
                                  onClick={() => fileInputRef.current.click()} 
                                />
                              ) : (
                                <Button 
                                  color="info" 
                                  
                                  onClick={() => fileInputRef.current.click()}
                                >
                                  Upload Image
                                </Button>
                              )}
                              <input 
                                type="file" 
                                style={{ display: 'none' }} 
                                accept="image/*" 
                                ref={fileInputRef} 
                                onChange={handleFileChange} 
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>

          {/* Modal for Whatsapp Detail */}
            <Modal isOpen={wModalVisible} toggle={() => setModalVisible(!wModalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb', paddingTop: '0px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ width: '75%' }}> 
                      <h5 style={{ margin: 0 }}>WhatsApp Detail</h5>
                    </div>  
                    <div style={{ width: '25%',  display: 'flex', justifyContent: 'flex-end', gap: '50px' }}>
                      <Button color="success" size="sm" onClick={sendWMsgToServer} disabled={sending}>
                        {sending ? 'Sending...' : 'Send'}
                      </Button>
                      <Button color="primary" size="sm"  onClick={() => {setWModalVisible(false);  setSelectedImage(null); }}>
                        Close
                      </Button>
                    </div>
                </div>  
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '58%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Mobile No</th>
                          <th colSpan='2'style={{ paddingLeft: '10px' }} >Customer Name</th>
                          <th colSpan='2' style={{ paddingLeft: '10px' }} >Area </th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                          {chekedNotify.map((row, index) => {
                              return (
                                <tr key={index} style={{ lineHeight: '10px' }} >
                                  <td className="cell-left"><span style={{ paddingLeft: '10px' }} >{row.custMo}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.custEName}</span></td>
                                  <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }}>{row.custAreaEName}</span></td>
                                </tr>
                              );
                          })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th style={{ paddingLeft: '10px' }} >Total</th>
                          <th colSpan='2' className="cell-left"  style={{ paddingLeft: '10px' }} >{chekedNotify.length}</th>
                          <th colSpan='2' ></th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', border: '2px solid #dcdcdc'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Gujarati</td>
                          <td className="cell-left">
                            <textarea 
                              value={gMsg} 
                              onChange={(e) => setGMsg(e.target.value)} 
                              rows="4" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">English</td>
                          <td className="cell-left">
                            <textarea 
                              value={eMsg} 
                              onChange={(e) => setEMsg(e.target.value)} 
                              rows="4" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="cell-left">Image</td>
                          <td className="cell-left">
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              
                              {imagePreview ? (
                                <img
                                  src={imagePreview}
                                  alt="Category"
                                  style={{
                                    width: '100px',
                                    height: '100px',
                                    objectFit: 'contain',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => fileInputRef.current.click()}
                                />
                              ) : (
                                <Button 
                                  color="info"
                                  onClick={() => fileInputRef.current.click()}
                                >
                                  Upload Image
                                </Button>
                              )}

                              <input
                                type="file"
                                style={{ display: 'none' }}
                                accept="image/*"
                                ref={fileInputRef}
                                onChange={(e) => { handleImageChange(e); handleFileChange(e); }}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
            </Modal>  

          {/* Modal for Customer Detail */}
            <Modal isOpen={custModalVisible} toggle={() => setModalVisible(!custModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Customer Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">ID : {selectedCustomer.custId}</td>
                        <td style={{ padding: '2px' }} className="cell-left">Mo No : {selectedCustomer.custMo}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px', fontSize: '14px', fontWeight: 'Bold' }} className="cell-left" >{selectedCustomer.custName}</td>
                        <td style={{ padding: '2px', fontSize: '14px', fontWeight: 'Bold' }} className="cell-left" >{selectedCustomer.custAdd}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Notitication Send : </td>
                        <td style={{ padding: '2px' }} className="cell-left">
                              <span style={{display: 'flex', padding: '2px', alignItems: 'center'}}>
                                <span style={{  width: '10px', height: '10px', borderRadius: '50%', backgroundColor: selectedCustomer.custPNToken === 'android' ? '#00962d' : '#000000', marginRight: '5px', marginLeft: '10px'}}></span>
                                <span>{selectedCustomer.custPNToken === 'android' ? 'Android ' : 'ios '}</span>
                                <span style={{ marginLeft: '15px' }}>{selectedCustomer.custLang}</span>
                              </span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Ref No : </td>
                        <td style={{ padding: '2px' }} className="cell-left">{selectedCustomer.custRefno}</td>
                      </tr>
                      <tr>
                        <td className="cell-left" style={{ padding: '2px' }}> Area</td>
                        <td style={{ padding: '2px' }} className="cell-left">{selectedCustomer.custAreaEName}</td>
                      </tr>
                      
                    </table>
                  </div>
                  <div >
                    <Button color="primary"  onClick={() => setCustModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default NotifyMaster;
